module.exports = __webpack_public_path__ + "img/LogOutZoomfromProfile.f82439f1.png";